(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-milan-feature]').forEach(feature => {
      if (feature.dataset.ready) return;
      feature.dataset.ready = 'true';
      const slides = [...feature.querySelectorAll('[data-milan-slide]')];
      const buttons = [...feature.querySelectorAll('[data-milan-finish]')];
      const name = feature.querySelector('[data-milan-finish-name]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, requested = 0, visible = false, hovered = false, focused = false, timer;
      let initialReady = slides[0].complete && slides[0].naturalWidth > 0;
      const show = async index => {
        requested = index;
        const slide = slides[index];
        if (slide.dataset.src) {
          slide.src = slide.dataset.src;
          delete slide.dataset.src;
        }
        try { await slide.decode(); } catch { return; }
        if (requested !== index) return;
        current = index;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        name.textContent = buttons[index].dataset.label;
      };
      const sync = () => {
        clearInterval(timer);
        if (initialReady && !reduced.matches && visible && !hovered && !focused && !document.hidden) timer = setInterval(() => show((current + 1) % slides.length), 2400);
      };
      if (!initialReady) slides[0].addEventListener('load', () => { initialReady = true; sync(); }, {once: true});
      buttons.forEach((button, i) => button.addEventListener('click', () => { show(i); sync(); }));
      feature.addEventListener('mouseenter', () => { hovered = true; sync(); });
      feature.addEventListener('mouseleave', () => { hovered = false; sync(); });
      feature.addEventListener('focusin', () => { focused = true; sync(); });
      feature.addEventListener('focusout', event => { focused = feature.contains(event.relatedTarget); sync(); });
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', sync);
      new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold: .15}).observe(feature);
      sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

